<template>
    <PopupVue
		:popupConfig="{
			showPopup: show,
			slot: true,
			width: '480px',
			popupTitle: '请验证',
		}"
		@cancel="handleClose"
		class="dialog-area"
	>
        <div class="dialog-content">
            <div v-if="captchaType === 1" class="pic-area">
                <Field
                    v-model="picCode"
                    center
                    placeholder="请输入验证码"
                    class="pic-input"
                >
                    <template #button>
                        <img id="pic-code-img" class="pic-code-img" :src="captchaParams?.picUrl" alt="" @click="handleRefreshPicCode">
                    </template>
                </Field>
                <img @click="handleRefreshPicCode(true)" class="pic-code-refresh hover-dom" src="@/assets/img/icon_shuaxin.png" alt="">
            </div>
            <div v-else class="geetest-area">
                <div id="gtest"></div>
            </div>
        </div>
        <div class="dialog-footer" v-if="captchaType === 1">
			<ButtonVue class="dialog-btn" :btnConfig="{type: 'green',txt: '提交>'}" @submit="handlePicCodeSubmit" />
        </div>
	</PopupVue>
</template>

<script>
import {
	Field,
	// Toast,
} from 'vant';

import {
	createUUID,
	storageEventEmit,
} from '@/lib/util';

import PopupVue from './Popup.vue';
import ButtonVue from './Button.vue';

export default {
	name: 'CaptchaComponent',
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		captchaType: {
			type: Number,
			default: 4,
		},
		captchaParams: {
			type: Object,
			default() {
				return {};
			},
		},
		submit: {
			type: Function,
			default: () => {},
		},
		cancel: {
			type: Function,
			default: () => {},
		},
	},
	components: {
		PopupVue,
		Field,
		ButtonVue,
	},
	data() {
		return {
			picCode: '',
			captchaInfo: {},
		};
	},
	created() {
	},
	mounted() {
	},
	methods: {
		init() {
			if (this.$props.captchaType === 4) {
				this.geeTestFunc(this.$props.captchaParams, () => {
					this.dialogSubmit();
				});
			}
		},
		dialogSubmit() {
			const captchaInfoTmp = this.captchaType === 1 ? { picCode: this.picCode } : this.captchaInfo;
			this.$emit('submit', captchaInfoTmp);
		},
		dialogCancel() {
			this.$emit('cancel', {});
		},
		handleClose() {
			this.dialogCancel();
		},
		handleRefreshPicCode(resetAll) {
			if (resetAll) {
				this.picCode = '';
			}
			document.querySelector('#pic-code-img').src = `${this.$props.captchaParams?.picUrl}&_t=${createUUID()}`;
		},
		handlePicCodeSubmit() {
			if (!this.picCode) {
				// Toast('请输入验证码！');
				storageEventEmit('show-toast', '请输入验证码！');
			} else {
				this.dialogSubmit();
			}
		},
		geeTestFunc(captchaParamsData, callBack) {
			const captchaParams = captchaParamsData || {};
			const gtestItem = captchaParams.gtData;
			const {
				gt,
				challenge,
			} = gtestItem;
			const offline = gtestItem.success !== 1;
			const newCaptcha = gtestItem.new_captcha === 1;

			this.$nextTick(() => {
				// 3.0版本
				// eslint-disable-next-line no-undef
				initGeetest({
					// 配置UI
					product: 'custom',
					area: '#gtest', // **必填参数**
					next_width: '280px',
					bg_color: 'black',
					// 动态参数
					gt,
					challenge,
					new_captcha: newCaptcha,
					offline,
					width: '280px',
				}, (captchaObj) => {
					// 模式：custom
					// eslint-disable-next-line no-undef
					document.querySelector('#gtest').innerHTML = '';
					captchaObj.appendTo('#gtest'); // 绑定到id为captcha的元素上

					captchaObj.onSuccess(() => {
						// 成功回调
						const data = {
							seccode: captchaObj.getValidate().geetest_seccode,
							validate: captchaObj.getValidate().geetest_validate,
							challenge: captchaObj.getValidate().geetest_challenge,
							password: 'gtest',
						};
						this.captchaInfo = {
							picCode: data.password,
							gtData: {
								challenge: data.challenge,
								validate: data.validate,
								seccode: data.seccode,
							},
						};

						this.$nextTick(() => {
							callBack();
						});
					});
				});
			});
		},
	},
	watch: {
		show(newValue, oldValue) {
			if (newValue !== oldValue && newValue) {
				this.init();
			}
		},
	},
};
</script>

<style scoped lang='scss'>
.dialog-area {
    padding: 15px;
    .dialog-header {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;

        .dialog-header-title {
            color: #222222;
            font-size: 15px;
        }

        img {
            position: absolute;
            right: 0;
            width: 30px;
        }
    }
    .dialog-content {
        .pic-area {
            display: flex;
            align-items: center;
            .pic-input {
                padding: 8px 12px;
                border-radius: 6px;
                border: 1px solid #D8D8D8;
            }
            .pic-code-img {
                height: 30px;
            }
            .pic-code-refresh {
                margin-left: 15px;
                width: 20px;
            }
			/deep/.van-cell {
				margin-bottom: 0;
			}
			/deep/.van-field__button {
				display: flex;
			}
        }
        .geetest-area {
            margin-bottom: 25px;
            #gtest {
                display: flex;
                justify-content: center;
            }
        }
    }
    .dialog-footer {
        margin: 20px 0;

        .dialog-btn {
            margin: 0 auto;
        }
    }
}
</style>
